import { FC } from 'react'
import { Content, ContentType } from '../../types/Content'
import { OnResponseSubmit, StepResponse } from '../../types/Exercise'
import TwitterPost from '../../components/Feed/TwitterPost'
import MediaPost from '../../components/Feed/MediaPost'

export interface ExerciseProps {
  id: number
  onResponseSubmit: OnResponseSubmit
  stepResponse?: StepResponse
}

interface SocialComponentProps {
  post: Content
  exerciseProps?: ExerciseProps
  isExercise?: boolean
}

export const SocialComponent: FC<SocialComponentProps> = ({
  post,
  exerciseProps,
  isExercise = false,
}) => {
  switch (post.type) {
    case ContentType.TWITTER:
      return (
        <TwitterPost
          isExercise={isExercise}
          post={post}
          exerciseProps={exerciseProps}
        />
      )
    case ContentType.INSTAGRAM:
    case ContentType.YOUTUBE:
      return (
        <MediaPost
          isExercise={isExercise}
          post={post}
          exerciseProps={exerciseProps}
          contentType={post.type}
        />
      )
    default:
      return <div>Unknown post</div>
  }
}

export const getSocialIcon = (type: ContentType) => {
  switch (type) {
    case ContentType.TWITTER:
      return 'twitter'
    case ContentType.YOUTUBE:
      return 'youtube'
    case ContentType.INSTAGRAM:
      return 'instagram'
    default:
      return ''
  }
}
